namespace TabAurous.Sales {
    export namespace TopBrandsService {
        export const baseUrl = 'Sales/TopBrands';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Sales/TopBrands/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>TopBrandsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
